<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6FYloV/tc-custom/9781504025355.jpg?1701061199229" alt="This image is the cover for the book Hangmen of Sleepy Valley, The Twister and Chuckaluck Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hangmen of Sleepy Valley, The Twister and Chuckaluck Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Two easygoing gunslingers take on a gang of vigilantes to save a quiet Texas ranch town</b><br/><br/> Twister Malone and Chuckaluck Thompson have no love for the sun-blasted plains of West Texas. They made their names in the cool mountain air of Colorado, and are headed to a friend’s hacienda in Mexico because, both at the ripe old age of thirty, they’re ready to retire. No more high-noon showdowns for Twister and Chuckaluck. They have years of roping, riding, and dozing to look forward to—but first they must survive the crucible of Sleepy Valley.<br/>  <br/> The two friends are passing through the idyllic patch of ranchland when they come across a quartet of bandits, wearing masks that reveal only one eye, hanging an innocent rancher from the tree. The gang of killers has terrorized Sleepy Valley for months, stringing up anyone brave enough to refuse their greedy demands. But Twister and Chuckaluck have never backed down from a fight, and they aren’t about to start. The sinister plot they uncover, however, will bring them face-to-face with the most dangerous desperadoes north of the Rio Grande.<br/>  <br/><i>The Hangmen of Sleepy Valley </i>is the 1st book in the Twister and Chuckaluck Mysteries, but you may enjoy reading the series in any order.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brett Halliday
      </h2>
      
      <p class="authorDescription body article">Brett Halliday (1904&ndash;1977) was the primary pseudonym of American author Davis Dresser. Halliday is best known for creating the Mike Shayne Mysteries. The novels, which follow the exploits of fictional PI Mike Shayne, have inspired several feature films, a radio series, and a television series.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09a4ddd8